import React, { useState,useEffect } from "react";
import { Button, Modal, Radio, message, Form } from "antd";
//Componentes Generales
// import TypeRequest from "../../../../components/User/Steps/TypeReq";
import Documents from "../../../../components/User/Steps/Documents";
import Data from "../../../../components/User/Steps/Data";
import Adress from "../../../../components/User/Steps/Adress";
import Additional from "../../../../components/User/Steps/Additional";
//Componentes Extranjero
import Resident from "../../../../components/User/Steps/Foreign/Resident";
import ForAdress from "../../../../components/User/Steps/Foreign/Adress";
//Funciones
import { ModalConfirm, Ast, ModalPreRegister } from "../../../../utils/Request/functions";
import { generaFolio } from "../../../../utils/Request/functions";
import useAuth from "../../../../hooks/useAuth";
import { lastName } from "../../../../utils/Request/functions";
import { Redirect, withRouter } from "react-router-dom";
import { Entities } from "../../../../components/User/Steps/Entities";
import { radioButton } from "../../../../utils/rules";
import { getDatosObservador, getEntidadesSeg, obtenDetallesPorProcesoPortal } from "../../../../api/requestPub";
import "../../../../components/User/Steps/Steps.scss";
import { ID_DOC_CRED_FRENTE, ID_DOC_CRED_VUELTA, ID_DOC_FOTOGRAFIA, MSN_GUARDAR, ORIGEN_PORTAL_PUBLICO } from "../../../../utils/constanst";

import {
  getEdad,
  getFechaNacimiento
} from "../../../../components/Generals/functions";

function Request(props) {

  const {
    history,
    setLoader,
    location: { state, modificar, ratificar, consultar },
  } = props; //Para utilizar la función push

  const [form] = Form.useForm();
  const [dataProcesoElectoral, setDataProcesoElectoral] = useState ({idProceso : 0 , idDetalle : 0, ambito: '', nombreProceso : ''})
  const [datos, setDatos] = useState({}); //Hook(Principal) para almacenar todos los datos del formulario
  const [files, setFiles] = useState({}); //Hook para almacenar las imagenes
  const [disabled, setDisabled] = useState({ num: false, btnSave: false }); //Hook para desactivar los campos de número exterior e interior y mostrar el modal de las fotografias
  const [disabledObs, setDisabledObs] = useState(false);
  const [ratifica, setRatifica] = useState(false);
  const [observador, setObservador] = useState([]);
  const [datosCP, setDatosCP] = useState({});
  //const [banderaCP, setBanderaCP] = useState(false);
  const [fechaJornada, setFechaJornada] = useState("");
  const [anioFechaJornada, setAnioFechaJornada] = useState("");
  const [validaClaveElector, setValidaClaveElector] = useState(false);

  const {
    ciudadano: { ciudadano, detalle },
  } = useAuth();

  const [juntas, setJuntas] = useState({ juntas: [], estados: [] });
  const [ambitoProceso, setAmbitoProceso]= useState({});

  /**
   * Constante booleana useState que permite mostrar u ocultar el combo de estados.
   * PEL2025
   */
  const [showComboEstados, setShowComboEstados] = useState(false);
  const [disabledRadio, setDisabledRadio] = useState(false);
  const [entSeguimiento, setEntSeguimiento] = useState([]);

  useEffect(() => {

    setLoader({ loading: true, message: MSN_GUARDAR }); //Se activa el loader

    if (ciudadano.id !== undefined && ciudadano.id !== null) {

      // ver si se hará precarga de la información y traer los datos del PEF
      getDatosObservador(ciudadano.id).then((res) => {

        //console.log('Desde Request en getDatosObservador', res.data.observador);

        if (res.data.observador !== undefined && res.data.observador !== null && res.data.observador.idObservador !== null) {

          if(modificar) {
            setDisabledObs(false);
            setRatifica(false);
          } else if(ratificar) {
            setDisabledObs(true);
            setRatifica(true);
          } else if(consultar) {
            setDisabledObs(true);
            setRatifica(false);
          } else {
            history.push("/ciudadano/inicio"); //Redirecciona a la pantalla principal
          }

          setDatos({ ...datos, tipoObservador : res.data.observador.tipoObservador});

          //console.log('Datos desde getDatosObservador--->', datos);

          form.setFieldsValue({
            tipoObservador: res.data.observador.tipoObservador,
            tipoSolicitud: res.data.observador.tipoSolicitud
          });

          //getProcess();
          
          setDatosCP({
            ...datosCP, 
            idProcesoAnterior : res.data.observador.idProcesoElectoral,
            idDetalleAnterior : res.data.observador.idDetalleProceso,
            idProcesoActual : datos.idProceso,
            idDetalleActual :  datos.idDetalle,
            idObservador : res.data.observador.idObservador,
            documentosObs : res.data.observador.documentosObs,
            origenSolicitud : ORIGEN_PORTAL_PUBLICO,
            estadoJunta : res.data.observador.idEstadoJunta,
            distritoJunta : res.data.observador.idDistritoFederal,
          });

          //setBanderaCP(true);
          res.data.observador.showTxtDiscapacidad = false

          if(res.data.observador.tieneDiscapacidad === 1){
            datos.discapacidad=1
          }

          //console.log('res.data.observador.tipoEntidad -->',res.data.observador.tipoEntidad );

          if ( res.data.observador.tipoEntidad === 1 ) {

            setShowComboEstados(true);

            var entidadesObservar = [];
            for (let i = 0; i < res.data.observador.entidadesObservar.length; i++) {
              if (res.data.observador.entidadesObservar[i].checked) {
                entidadesObservar.push(''+res.data.observador.entidadesObservar[i].value+'');
              }
            }

            //console.log('entidadesObservar-->',entidadesObservar);
 
            form.setFieldsValue({
              entidades: entidadesObservar,
            });

          } else {
            setShowComboEstados(false);
          }
          setObservador(res.data.observador);

          getEntidadesSeg().then((res2) => {

            for (let i = 0; i < res2.data.length; i++) {
              if(res2.data[i].idDetalleProceso===res.data.observador.idDetalleProceso){
                setAmbitoProceso(res2.data[i].ambito.toString());
              }
            }

            /* 
              PEL2025. Valida que si la Entidad del domicilio del solicitante no esta dentro de las etidades de seguimiento 
              se desabilite el radio de "Solo en la entidad de mi credencial".
            */
            for (let i = 0; i < res2.data.length; i++) {
              if ( Number(res.data.observador.idEstado) === res2.data[i].id.idEstado ) {
                setDisabledRadio(false);
                break;
              } else {
                setDisabledRadio(true);
              }
            }

          }).catch((error) => {
            console.log("Ocurrio un error", error);
          });

        } else {
          setAmbitoProceso("sin proceso");
        }

        setLoader({ loading: false, message: "" }); //Se desactiva el loader
      });      
         
    } else {
      setAmbitoProceso("sin proceso")
      setLoader({ loading: false, message: "" }); //Se desactiva el loader
    }

    //Se setean algunos datos necesarios para saber el tipo de proceso
    obtenDetallesPorProcesoPortal(ciudadano.idProceso).then(res=>{

      if (res.data && res.data.length>0){
        setDataProcesoElectoral({
          idProceso     :  ciudadano.idProceso,
          idDetalle     : res.data[res.data.length-1].idDetalle,
          nombreProceso : res.data[res.data.length-1].nombreProceso,
          ambito        : res.data[res.data.length-1].ambito,
        });
      }

    }).catch((error) => {
      console.log(error);
    });

    // PEL2024-2025
    getEntidadesSeg().then((res2) => {

      setEntSeguimiento(res2.data);

    }).catch((error) => {
      console.log("Ocurrio un error", error);
    });
  
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Se valida que acceda desde la pantalla principal
  if (state === undefined) {
    return (
      <>
        <Redirect to="/ciudadano/inicio" />
      </>
    );
  }

  //Función que va almacenando la información de cada input
  const handleChange = (input) => (event) => {

    if (input === "fechaNac") {
      event != null
        ? setDatos({ ...datos, [input]: event.format("YYYY-MM-DD") })
        : setDatos({ ...datos, [input]: null });

      let edadCiudadano = getEdad(event);

      form.setFieldsValue({
        edad: edadCiudadano.toString(),
      });

      setDatos({
        ...datos,
        edad: edadCiudadano.toString(),
      });

    } else {

      //PEL2025
      if ( input === "entObservar" ) {
        if ( event.target.value === 1 ) {
          setShowComboEstados(true);
        } else {
          setShowComboEstados(false);
          form.setFieldsValue({
            entidades: [],
          });
        }
      }

      setDatos({ ...datos, [input]: event.target.value }); //Se almacena la información en el hook
    }
  };

  //Función que limpia el hook datos cada vez que se cambia el lugar de residencia
  const handleChangeType = (input) => (event) => {

    form.resetFields();

    if ( !modificar ) {
      form.setFieldsValue({
        elector: null,
        entidad: null,
        municipio:null,
        calle:null,
        codigoPostal:null,
        juntaEjecutiva:null
      })
      setDatos({});
    }

    setFiles({});

    //PEL2024-2025
    //setJuntas({ juntas: [], estados: [] });

    setDatos({ 
      ...datos,
      idProceso     : dataProcesoElectoral.idProceso,
      idDetalle     : dataProcesoElectoral.idDetalle,
      nombreProceso : dataProcesoElectoral.nombreProceso, //Se mantienen los datos del proceso
      [input]: event.target.value 

    }); //Se almacena la información en el hook

    form.setFieldsValue({//Se necesita asginarle al Radio su mismo valor ya que se resetearon todos los valores del form
      [input]: event.target.value,
    })

    /* 
      PEL2024-2025. Se establace por default a cero el "¿Va a realizar la observación de la elección de manera presencial en el extranjero?"
      ya que para este proceso no hay voto en el extranjero.
      Por lo que el usuario pidio que se desabilite
    */
    form.setFieldsValue({
      votoExtranjero: 0
    });

  };
  
  //Función que alamacena la información de lo select
  const changeSelect = (input) => (event) => {

    setDatos({ ...datos, [input]: event });

    if ( input === "entidad" ) {

      /* 
        PEL2025: Valida que si la Entidad del domicilio del solicitante no esta dentro de las etidades de seguimiento 
        se desabilite el radio de "Solo en la entidad de mi credencial".
      */
      for (let i = 0; i < entSeguimiento.length; i++) {
        if (Number(event) === entSeguimiento[i].id.idEstado) {
          setDisabledRadio(false);
          break;
        } else {

          setDisabledRadio(true);
          setShowComboEstados(false);

          form.setFieldsValue({
            entObservar: null,
            entidades:[]
          });
        }
      }
    }

  };

  //Función que almacena la información de los checkbox
  const changeCheckbox = (input) => (event) => {

    setDatos({ ...datos, [input]: event.target.checked });

    if (input === "numero") {

      //Valida si el el checkbox llamado numero
      if (event.target.checked) {

        form.setFieldsValue({
          //Limpia los inputs de numero exterior e interior
          numeroExt: (datos.numeroExt = ""),
          numeroInt: (datos.numeroInt = ""),
        }); //Obtiene la información y la almacena

        setDatos({ ...datos, [input]: event.target.checked });

        setDisabled({ num: true }); //Bloquea los inputs

      } else {
        setDisabled({ num: false }); //Habilita los inputs
      }
    }
  };

  //Función que regresa a la pagina de tipo de solicitud
  const back = () => {
    history.push("/ciudadano/inicio");
  };

  //Función que obtiene los datos del formulario
  const saveRequest = () => {

    form.validateFields().then((values) => {

      //console.log('saveRequest() datos -->',datos);     

      //tipoSolicitud = 1- organización
      if ( datos.tipoSolicitud === 1 && 
          (datos.organizacion === undefined || datos.organizacion === null || datos.organizacion === "" || datos.idOrganizacion === -1) ) {

        Modal.warning({
          title: "Atención",
          content: "Es necesario realizar la búsqueda del código de Organización.",
        });
        return;
      }

      if(validaClaveElector) {
        Modal.warning({
          title: "Atención",
          content: "Confirme que la clave de elector sea correcta.",
        });
        return;
      }

      if ( values.codigoPostal !== undefined && 
           values.codigoPostal !== null && 
           values.codigoPostal !== "" && 
           Number(values.codigoPostal) === 0 ) {

        Modal.warning({
          title: "Atención",
          content: "Para poder continuar se requiere ingresar la sección electoral, favor de validar.",
        });

      } else {

          //tipoSolicitud = 0- Individual

          let fechaCiudadano = getFechaNacimiento(values.elector.toUpperCase());
          let edadCiudadano = getEdad(fechaCiudadano);

          if ( edadCiudadano < 17 ) {
            Modal.warning({
              title: "Atención",
              content: "La clave de elector es incorrecta.",
            });
            return;
          }

          let name = lastName(datos.paterno, datos.materno);
          if (!name) {
            //Se verifica que al menos tenga un apellido
            Modal.warning({
              title: "Atención",
              content: "Al menos un apellido es obligatorio.",
            });
            return;
          }

          if (!files.credAnverso || !files.credReverso || !files.foto) {
            Modal.warning({
              title: "Atención",
              content: "Documentación personal requerida.",
            });

            return;

          } else {

            /**
               PEL2025: Se solicito que el usuario pueda seleccionar las entidades que desea observar. 
                        Por lo cual se agrega a la condición para proceseo federal o local.
                        Si deseas el comportamiento solo para federal quita la opcion || ambitoProceso === "L"
            */
            if ( ambitoProceso === 'F' || ambitoProceso === 'L' ) {

              if ( values.entObservar === 0 ) {
                //console.log('En el IF datos.idEntidad::',datos.idEntidad);
                datos.entidades = [datos.idEntidad];
              } else {
                //console.log('ELSE values.entidades::',values.entidades);
              	datos.entidades = values.entidades;
              }
            }

            //console.log('2- datos-->',datos);

            /**
               PEL2025: Se solicito que el usuario pueda seleccionar las entidades que desea observar. 
                        Por lo cual se agrega a la condición para proceseo federal o local.
                        Si deseas que se desactive la parte de etidades a observar descomenta esta condición.
            */
            //if( ambitoProceso === "L" ) {
              //Para PEL2022 que desaparece la sección de etidades a observar 
              //var entidadSeleccionada = [];
              //entidadSeleccionada.push(datos.entidadJunta);
              //datos.entidades = entidadSeleccionada;
            //}

            //*-+ Se fija la modalidad en presencial para la --
            //datos.capacitacion = 2;

            datos.idCuenta = ciudadano.idCuenta; //Se obtie el idCuenta del ciudadano
            datos.correo = ciudadano.sub; //Se obtie el correo del ciudadano
            datos.idCuenta = ciudadano.idCuenta; //Se obtie el idCuenta del ciudadano
            datos.correo = ciudadano.sub; //Se obtie el correo del ciudadano
            datos.idProceso = ciudadano.idProceso;
            datos.elector = datos.elector.toUpperCase();

            if (dataProcesoElectoral.ambito === 'F'){//Se verifica si es elección federal para crear el folio
              let anioArray = datos.nombreProceso.split(/[- ]/);//Divide la casdena para obtener el año
              let datosFederal ={
                ambitoDetalle : dataProcesoElectoral.ambito,
                tipoProceso   : '',
                anio          : anioArray[anioArray.length-1]
              }
              datos.folio = generaFolio (datosFederal);
            } 

            getTipoObservador(values);
            getProcess(); //Se obtiene los datos de la función

            setDisabled({ btnSave: true, loading: true }); //Se deshabilita el botón de guardar

            // Nombre entidad de la junta de seguimiento
            for (let i = 0; i < juntas.estados.length; i++) {
              if (datos.entidadJunta === juntas.estados[i].id.idEstado) {
                datos.conEntidad = juntas.estados[i].nombreEstado;
              }
            }

            // Fecha de nacimiento
            datos.fechaNac = values.fechaNac.format("YYYY-MM-DD"); 

            // PEL2024-2025 
            datos.convocatoriaOrigenCatalogo = values.convocatoriaOrigenCatalogo;
            datos.convocatoriaOrigen = values.convocatoriaOrigen;
            datos.votoExtranjero = values.votoExtranjero;
            datos.tipoDiscapacidad = values.tipoDiscapacidad;
            datos.entObservar = values.entObservar;

            console.log('Antes del ModalConfirm datos--->', datos);
            console.log('Antes del ModalConfirm values--->', values);

            //console.log('Antes del ModalConfirm datos.convocatoriaOrigen::::', datos.convocatoriaOrigen);
            //console.log('Antes del ModalConfirm datos.convocatoriaOrigenCatalogo::::', datos.convocatoriaOrigenCatalogo);

            ModalConfirm(datos, files, history, setDisabled, setLoader, modificar, observador, ciudadano); //Se muestra el alert
          }
      }
    }).catch((error)=>{
      console.log(error);
      message.info("Los datos con ( * ) son requeridos.");
    });
  };

  //Función temporal para el registro de un observador del PEF para la CP
  const savePreRequest = () => {
    //Validación de que haya carga correcta de los documentos/imagenes 
    let validacionDoc = true;
    for(let i = 0; i < datosCP.documentosObs.length; i++) {
      switch(datosCP.documentosObs[i].cTiposDocumento.idTipoDocumento) {
        case ID_DOC_CRED_FRENTE:
        case ID_DOC_CRED_VUELTA:
        case ID_DOC_FOTOGRAFIA:
          if(datosCP.documentosObs[i].urlImagen === null) {
            validacionDoc = false; //No paso validación de los documentos/imagenes
          }
          break;
        default:
          break;
      }
    }
    if(validacionDoc) {
      form.validateFields().then((values) => {
          //getProcess(); //Se obtiene los datos de la función
          setDisabled({ btnSave: true, loading: true }); //Se deshabilita el botón de guardar
          getProcess();
          datosCP.idProcesoActual = datos.idProceso;
          datosCP.idDetalleActual =  datos.idDetalle;
          datosCP.distritoJuntaActualizar = datos.juntaEjecutiva;
          datosCP.estadoJunta = datos.entidadJunta;
          datosCP.edad = parseInt(form.getFieldValue("edad"));
          ModalPreRegister(datosCP, history, setDisabled, setLoader); //Se muestra el alert
      }).catch((error)=>{
          console.log(error);
          Modal.warning({
            title: "Atención",
            content: "Para poder continuar se requiere ingresar los datos faltantes, favor de validar.",
          });
      });
    } else {
      Modal.warning({
        title: "Atención",
        content: "Hay un problema con la carga de los documentos requeridos. Favor de contactar a tu Junta Ejecutiva.",
      });
    }
  };

  //Función temporal que obtiene el proceso, detalle y el folio
  const getProcess = () => {

    /* datos.idProceso = detalle[0].idProcesoElectoral;
    datos.idDetalle = detalle[0].idDetalleProceso;
    datos.nombreProceso = detalle[0].nombreProceso; */

    for (let i = 0; i < detalle.length; i++) { //PARA PROCESOS LOCALES
      if(detalle[i].idEstado === datos.entidadJunta) {
        datos.idProceso = detalle[i].idProcesoElectoral;
        datos.idDetalle = detalle[i].idDetalleProceso;
        datos.nombreProceso = detalle[i].nombreProceso;
        datos.folio = generaFolio(detalle[i]);
        //Por si es ratificacion
        datosCP.folio = generaFolio(detalle[i]);
      }
    }
  };

  //Función que le asigna los valores al hook
  const getTipoObservador = (values) => {

    datos.paterno = values.paterno && values.paterno.trim();
    datos.materno = values.materno && values.materno.trim();
    datos.nombre = values.nombre.trim();
    datos.ocupacion = values.ocupacion && values.ocupacion.trim();
    datos.celular = values.celular;
    datos.telefono = values.telefono;

    //Extranjero
    if (datos.tipoObservador === 1) {
      datos.estadoExt = values.estadoExt && values.estadoExt.trim();
      datos.ciudad = values.ciudad && values.ciudad.trim();
    }
  };

  //Componente que renderiza los botones de Guardar y regresar
  const ButtonSave = () => {
    return (
      <Form.Item style={{ textAlign: "center" }}>
        <Button
          type="default"
          onClick={() => back()}
          disabled={disabled.btnSave}
        >
          Regresar
        </Button>
        {" "}
        {!disabledObs && (observador.idObservador === undefined || observador.idObservador === null) && (<Button
            type="primary"
            onClick={() => saveRequest()}
            //style={{ width: 350 }}
            className="btnSave"
            disabled={!datos.compromiso || !datos.comCorreo || disabled.btnSave} >

          Guardar y enviar a validación
        </Button>)}

        {disabledObs && ratificar && (<Button
          type="primary"
          onClick={() => savePreRequest()}
          //style={{ width: 350 }}
          className="btnSave"
        >
          Confirmar datos del Observador
        </Button>)}
        {modificar && (<Button
          type="primary"
          onClick={() => saveRequest()}
          //style={{ width: 350 }}
          className="btnSave"
        >
          Modificar datos del Observador
        </Button>)}
      </Form.Item>
    );
  };

  return (
    <div style={{ marginTop: 50 }}>
      <h1>Solicitud</h1>
      <hr />
      <p style={{ marginTop: 30 }}>
        Los datos marcados con ( <Ast /> ) son obligatorios
      </p>
      <h3>
        <Ast /> Lugar de residencia
      </h3>
      <Form form={form}>

        <Form.Item  rules = {radioButton}
                    initialValue= {datos.tipoObservador}
                    name="tipoObservador" >

          <Radio.Group onChange={handleChangeType("tipoObservador")} 
                       disabled={disabledObs}>

            <Radio value={0}>Territorio mexicano</Radio>
            <Radio value={1}>Extranjero</Radio>

          </Radio.Group>

        </Form.Item>

      </Form>

      {/**Se habilita el tipo de formulario si es nacional o extranjero  */}
      {datos.tipoObservador === 0 && (
        <>
          {/* <TypeRequest
            handleChange={handleChange} //Se envia la funcion
            datos={datos} //se manda el hook de los valores
            getFieldDecorator={getFieldDecorator} //Se envia para validar los inputs
            form={props.form}
            setDatos={setDatos}
          /> */}

          <Data handleChange={handleChange} //Se envia la funcion
                datos={datos} //se manda el hook de los valores
                changeSelect={changeSelect} //Función del select
                form={form}
                setDatos={setDatos}
                disabledObs={disabledObs}
                observador={observador}
                modificar={modificar}
                consultar={consultar}
                setValidaClaveElector={setValidaClaveElector}                
                entSeguimiento={entSeguimiento}
                setDisabledRadio={setDisabledRadio}                
                setShowComboEstados={setShowComboEstados} />

          <Adress handleChange={handleChange} //Se envia la funcion
                  datos={datos} //se manda el hook de los valores
                  changeCheckbox={changeCheckbox}
                  disabled={disabled} //Para habilitar los inputs
                  setDatos={setDatos}
                  form={form}
                  setJuntas={setJuntas}
                  juntas={juntas}
                  disabledObs={disabledObs}
                  observador={observador} 
                  changeSelect={changeSelect} />

          <Additional dataProcesoElectoral = {dataProcesoElectoral}
                      handleChange={handleChange}
                      datos={datos}
                      setDatos = {setDatos}
                      changeSelect={changeSelect}
                      form={form}
                      juntas={juntas}
                      setJuntas={setJuntas}
                      disabledObs={disabledObs}
                      ratifica={ratifica}
                      observador={observador}
                      detalle={detalle}
                      setFechaJornada={setFechaJornada}
                      setAnioFechaJornada={setAnioFechaJornada}
                      modificar={modificar}
                      consultar={consultar}
                      setLoader={setLoader}
                      ambitoProceso={ambitoProceso}
                      setAmbitoProceso={setAmbitoProceso} 
                      showComboEstados={showComboEstados}
                      disabledRadio={disabledRadio} />

          <Entities handleChange={handleChange}
                   datos={datos}
                   setDatos={setDatos}
                   form={form}
                   disabledObs={disabledObs}
                   observador={observador}
                   ambitoProceso={ambitoProceso} />
          
          <Documents setFiles={setFiles}
                    files={files}
                    datos={datos}
                    changeCheckbox={changeCheckbox}
                    setDisabled={setDisabled}
                    formVal={form}
                    disabledObs={disabledObs}
                    observador={observador}
                    fechaJornada={fechaJornada}
                    anioFechaJornada={anioFechaJornada} />

          {/* Boton de Guardar-Regresar - Se reutiliza el componente  */}
          <ButtonSave />
        </>
      )}

      {form.getFieldValue("tipoObservador") === 1 && (
        <>
          {/*Componente solo para extrnjeros */}
          <Resident handleChange={handleChange} //Se envia la funcion
                    datos={datos} //se manda el hook de los valores
                    changeSelect={changeSelect} //Función del select
                    setDatos={setDatos}
                    disabledObs={disabledObs}
                    observador={observador}
                    form={form} />

          {/* Data - Se reutiliza el componente  */}
          <Data handleChange={handleChange} //Se envia la funcion
                datos={datos} //se manda el hook de los valores
                changeSelect={changeSelect} //Función del select
                setDatos={setDatos}
                form={form}
                disabledObs={disabledObs}
                observador={observador}
                modificar={modificar}
                consultar={consultar}
                setValidaClaveElector={setValidaClaveElector} 
                entSeguimiento={entSeguimiento}
                setDisabledRadio={setDisabledRadio}                
                setShowComboEstados={setShowComboEstados}/>

          {/*Componente solo para extranjeros-Dirección */}
          <ForAdress  setJuntas={setJuntas}
                      handleChange={handleChange} //Se envia la funcion
                      datos={datos} //se manda el hook de los valores
                      changeCheckbox={changeCheckbox}
                      disabled={disabled} //Para habilitar los inputs
                      disabledObs={disabledObs}
                      observador={observador}
                      form={form} />

          {/*  Additional- Se reutiliza el componente  */}
          <Additional handleChange={handleChange}
                      datos={datos}
                      changeSelect={changeSelect}
                      form={form}
                      juntas={juntas}
                      setJuntas={setJuntas}
                      disabledObs={disabledObs}
                      observador={observador}
                      ratifica={ratifica}
                      detalle={detalle}
                      setFechaJornada={setFechaJornada}
                      setAnioFechaJornada={setAnioFechaJornada}
                      modificar={modificar}
                      consultar={consultar}
                      setLoader={setLoader}
                      setDatos={setDatos}
                      ambitoProceso={ambitoProceso}
                      setAmbitoProceso={setAmbitoProceso}
                      showComboEstados={showComboEstados}
                      disabledRadio={disabledRadio} />

          {/*  Entities- Se reutiliza el componente  */}
          <Entities handleChange={handleChange}
                    datos={datos}
                    setDatos={setDatos}
                    form={form}
                    disabledObs={disabledObs}
                    observador={observador} />

          {/*  Documents - Se reutiliza el componente  */}
          <Documents  setFiles={setFiles}
                      files={files}
                      datos={datos}
                      changeCheckbox={changeCheckbox}
                      setDisabled={setDisabled}
                      formVal={form}
                      disabledObs={disabledObs}
                      observador={observador}
                      fechaJornada={fechaJornada}
                      anioFechaJornada={anioFechaJornada} />

          {/* Boton de Guardar-Regresar - Se reutiliza el componente  */}
          <ButtonSave />
        </>
      )}
    </div>
  );
}
const requestForm = Request
export default withRouter(requestForm);
